import * as React from 'react';
import * as vars from '../../consts/variables';
import loadable from '@loadable/component';

const CustomSelect = loadable(() => import('../../components/CustomSelect/CustomSelect'));

const styles: Record<string, React.CSSProperties> = {
    flag: {
        width: '15px',
        height: '15px',
        marginRight: '5px',
    },
    option: {
        padding: '5px',
        display: 'flex',
        alignItems: 'center',
        minHeight: '100%',
    },
};

interface IOptionProp {
    option: ICountryCodeValue;
    onSelect(ICountryCodeValue): void;
}

class OptionComponent extends React.Component<IOptionProp, {}> {
    handleClick = () => this.props.onSelect(this.props.option);

    render() {
        return (
            <div onClick={this.handleClick} style={styles.option}>
                {this.props.option.icon && (
                    <span>
                        <img
                            style={styles.flag}
                            height={15}
                            width={15}
                            src={this.props.option.icon}
                            alt={''}
                        />
                    </span>
                )}
                <span>{this.props.option.label}</span>
            </div>
        );
    }
}

function ValueComponent(props) {
    return (
        <div style={styles.option}>
            {props.value.icon && (
                <img style={styles.flag} height={15} width={15} src={props.value.icon} alt={''} />
            )}
            <span>{props.value.label}</span>
        </div>
    );
}

export interface ICountryCodeValue {
    value: string;
    label?: string;
    icon?: string;
}

interface IProps {
    options: ICountryCodeValue[];
    value: ICountryCodeValue;
    onChange(value: ICountryCodeValue);
    placeholder?: string;
    isError: boolean;
    testSelectorName?: string;
}

export function CountryCodeSelect(props: IProps) {
    const selectStyle: any = {
        border: props.isError ? `1px solid ${vars.pink}` : `1px solid ${vars.gray}`,
        color: props.value && props.value.value === '-1' ? vars.mediumBlack : vars.black,
    };
    return (
        <CustomSelect
            value={props.value}
            valueComponent={ValueComponent}
            options={props.options}
            optionComponent={OptionComponent}
            onChange={props.onChange}
            clearable={false}
            searchable={false}
            placeholder={props.placeholder}
            style={selectStyle}
            testSelectorName={props.testSelectorName}
        />
    );
}
